import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import store from 'store';

import { IResetPasswordTokenData } from '@common/api/auth';
import FormField from '@common/components/FormField';
import { enqueueSnackbar } from '@common/components/SnackBar';

import Layout from '../../components/Layout';
import schema, { ConfirmPasswordFormValues } from './schema';

function ConfirmPassword() {
	const { resetPasswordToken } = useParams();
	const navigate = useNavigate();

	const handleSubmit = async (values: IResetPasswordTokenData) => {
		try {
			await store.auth.resetPasswordToken(resetPasswordToken, values as IResetPasswordTokenData);
			navigate('/');
			enqueueSnackbar('The new password has been saved');
		} catch (e) {
			console.error('Reset Password Confirm Error', e);
			throw e;
		}
	};

	return (
		<Layout<ConfirmPasswordFormValues>
			header="Mail is confirmed"
			headerText="Come up with a unique password to log in to the platform"
			buttonText="Continue"
			initialValues={{
				password: '',
				password_confirmation: '',
			}}
			onSubmit={handleSubmit}
			validationSchema={schema()}
		>
			<FormField label="New password" type="password" name="password" />
			<FormField label="Confirm password" type="password" name="password_confirmation" />
		</Layout>
	);
}

export default observer(ConfirmPassword);
